/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React from "react";
import Tooltip from "./../../../Tooltip/Tooltip";
import Warning from "@material-ui/icons/Warning";
import { constant } from "./../../../shared/constants/constants";
import { makeStyles } from "@material-ui/core/styles";

// colored name initials
const NickNames = ({ workOrders }) => {
  const classes = useStyles();
  let renderer = [];
  let alreadyPresent = {};
  for (let w of workOrders) {
    if (w.userNameId) {
      if (alreadyPresent[w.userNameId]) continue;
      alreadyPresent[w.userNameId] = true;
      renderer.push(
        <Tooltip title={w.userName} arrow>
          {global.userColor[w.userNameId] &&
          global.userColor[w.userNameId].photoUrl ? (
            <img
              className={classes.twoLetter}
              src={global.userColor[w.userNameId].photoUrl}
              alt={w.nickName}
            />
          ) : (
            <p
              className={classes.twoLetter}
              style={{
                backgroundColor: global.userColor[w.userNameId]
                  ? global.userColor[w.userNameId].colorCode
                  : w.nickBg,
              }}>
              {w.nickName}
            </p>
          )}
        </Tooltip>
      );
    } else {
      if (alreadyPresent["unassigned"]) continue;
      alreadyPresent["unassigned"] = true;
      renderer.push(
        <Tooltip
          className={classes.warningIcon}
          title={constant.NO_TECHNICIAN_CONTRACTOR_ASSIGNED}
          arrow>
          <Warning color="inherit" fontSize="inherit" />
        </Tooltip>
      );
    }
  }
  return renderer;
};

const useStyles = makeStyles((theme) => ({
  twoLetter: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
    fontSize: "18px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "2px",
  },
  warningIcon: {
    color: "#F28E1A",
    fontSize: "35px",
  },
}));

export default React.memo(NickNames);
